// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__12lRn","signatureButtonsRight":"ModalSign_signatureButtonsRight___-rwD"};